<template>
  <v-fade-transition>
    <wgu-module-card v-bind="$attrs" :moduleName="moduleName" :icon="icon" class="card3d " v-bind:class="{ card3dFull: isMaximized }"
    :width=winwidth :height=winheight :showHeaderToolbar="showHeaderToolbar">

      <div v-show="!isMaximized">

        <!--
    <v-card-title primary-title>
      <div>
        <h3 class="text-h5 mb-0" v-if="$t('wgu-3d-button.title')">{{ $t('wgu-3d-button.title') }}</h3>
        <v-icon :icon=icon></v-icon>

      </div>
    </v-card-title>
  -->
        <v-card-text class="text-lg-body-1 text-body-2">
          <p class="onprimary--text">
            <b>Willkommen in der 3-D Ansicht der Starkregengefahrenkarte für Köln!</b>
          </p>
          <p>
            Die Karte zeigt Ihnen das persönliche Risiko bei Starkregen in einer dreidimensionalen Darstellung.
          </p>
          <p>
            Der Einstieg in die Anwendung erfolgt mittels Adresseingabe oder durch Auswahl der Schaltfläche
            „Kartenausschnitt“.
          </p>
          <p>
          <v-card-text style="display: flex;">
            <!-- TODO Texte finalisieren, in i18n -->
            <v-spacer></v-spacer>
            <v-btn large prepend-icon="zoom_out_map" class="adjustPadding" @click="startOnMapCenter" color="onprimary">
              <v-icon color="primary">zoom_out_map</v-icon>
              <v-card-text class="primary--text adjustPadding">Kartenausschnitt</v-card-text>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn large prepend-icon="home" class="adjustPadding" @click="startOnAddress" color="onprimary" v-if="address">
              <v-icon color="primary">home</v-icon>
              <v-card-text class="primary--text adjustPadding">{{ address }}</v-card-text>
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-text>
        </p>
          <!--
          <v-card-text v-if="!address">
            Wenn bereits nach einer Adresse gesucht wurde, kann auch auf diese Adresse gezoomt werden
          </v-card-text>
          -->
          <v-spacer></v-spacer>

        <p>
          In der so geladenen 3-D Ansicht haben Sie nun die Möglichkeit, detaillierte Informationen zu Wassertiefen und
          Fließgeschwindigkeiten abzulesen. Sie können den Blickwinkel auf Ihr Gebäude oder Grundstück ändern und durch
          Rein- und Rauszoomen einen Überblick über die Überflutungssituation in Ihrer Umgebung erlangen.
        </p>
        <p>
          Eine ausführliche Kurzanleitung zur Nutzung der 3-D Starkregengefahrenkarte finden Sie unter „Hilfe“ in der
          3-D Ansicht oder unter diesem Link: <a href="static/html/KurzanleitungStarkregen3D.pdf" target="Hilfe3D">Kurzanleitung Starkregen3D (PDF)</a>
        </p>
        <br/>
        <p>
          Wir wünschen Ihnen viel Freude beim Ausprobieren!
        </p>
        <br/>
      </v-card-text>

      </div>
      <!-- hora3d / visdom Root für 3D-->
      <div id="hora3d" v-show="isMaximized">
        <div id="visdomRoot" style="width: 100%; height: 100%; transform: unset; inset: 0 !important "></div>
      </div>

    </wgu-module-card>
  </v-fade-transition>
</template>

<script>
// the module card is a the template for a typical Wegue module
import ModuleCard from '../../../src/components/modulecore/ModuleCard';
// we import a so called "mixin" that helps us to interact with the map
import { Mapable } from '../../../src/mixins/Mapable';
// an OpenLayers helper function to display coordinates
import { toStringXY } from 'ol/coordinate';
// an OpenLayer helper function to transform coordinate reference systems
import { transform } from 'ol/proj.js';

import { WguEventBus } from '../../../src/WguEventBus'

export default {
  name: 'wgu-3d-button',
  // make sure to register the 'Mapable' mixin
  mixins: [Mapable],
  inheritAttrs: false,
  components: {
    'wgu-module-card': ModuleCard
  },
  created () {
    WguEventBus.$on('button3d_update_Address', this.updateAddress);
    WguEventBus.$on(this.moduleName + '-visibility-change', this.windowStateChange);
    WguEventBus.$on('button3d_update_scenario', this.setScenario);
  },
  props: {
    icon: { type: String, required: false, default: 'star' }
  },
  mounted () {
    // console.log(this.$parent.$el.offsetHeight);
  },

  computed: {
    /* // nicht verwenden, da sonst Mximierung überschrieben wird
    winwidth () {
      return this.minimizeWindow()[0];
    },
    winheight () {
      return this.minimizeWindow()[1];
    }
      */
  },
  // here we define variables that are used in the HTML above
  data () {
    return {
      moduleName: 'wgu-3d-button',
      zoom: '',
      center: '',
      mapextent: null,
      address: null,
      addressLon: null,
      addressLat: null,
      lon: null,
      lat: null,
      isMaximized: false,
      showHeaderToolbar: true,
      winwidth: this.minimizeWindow()[0],
      winheight: this.minimizeWindow()[1],
      hora3dHeight: 200,
      scenario: '101_global',
      scenarios: {
        sr030: '100_global',
        sr050: '101_global',
        sr100: '102_global',
        sr200: '103_global'
      }
    };
  },
  methods: {
    /**
     * This function is called once the map is bound to the application
     */
    windowStateChange (newState) {
      if (!newState) {
        // console.log('window State Change');
        const newMinimizedSize = this.minimizeWindow()
        this.winwidth = newMinimizedSize[0];
        this.winheight = newMinimizedSize[1];
      }
    },

    startOnMapCenter () {
      // get center of map
      const view = this.map.getView();
      this.extractMapViewProperties(view);

      this.startHora3d();
    },
    startOnAddress () {
      this.lon = this.addressLon
      this.lat = this.addressLat

      this.startHora3d();

      this.extractMapViewProperties(this.map.getView());
    },
    setScenario (scenario) {
      if (scenario in this.scenarios) {
        this.scenario = this.scenarios[scenario];
      }
    },
    minimizeWindow () {
      let wWidth = 500;
      // let wHeight = 500;

      this.isMaximized = false;
      // this.winwidth = "90%";
      // this.winheight = "90%";

      this.unloadHora3d(false);

      this.showHeaderToolbar = true;

      // TODO Orientation beachten?
      /* TODO Werte überarbeiten, v.a. für kleine Bildschirme */
      /* TODO Min/Max Height statt height? */
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          wWidth = '90%';
          // wHeight = '90%';
          break;
        case 'sm':
          wWidth = '75%';
          // wHeight = '75%';
          break;
        case 'md':
          wWidth = 650;
          // wHeight = 525;
          break;
        case 'lg':
          wWidth = 700;
          // wHeight = 600;
          break;
        case 'xl':
          wWidth = 800;
          // wHeight = 625;
          break;
      }

      // return [wWidth, wHeight];
      return [wWidth, 'auto'];
    },
    maximizeWindow () {
      this.isMaximized = true;
      /*
      this.winwidth = '90%';
      this.winheight = '90%';

      if (this.$vuetify.breakpoint.name === 'xs') {
        this.winwidth = '95%';
        this.winheight = '95%';
      }
      */

      this.winwidth = '100%';
      this.winheight = '100%';

      this.showHeaderToolbar = false;
    },
    startHora3d () {
      this.maximizeWindow();

      const visdomRoot = document.getElementById('visdomRoot');
      // console.log(this.lat, this.lon, this.scenario, this.address);
      window.VISDOM.subscribe('close', () => this.unloadHora3d(true));
      // TODO: Reihenfolge Paramter wie in Example (hier) oder wie ion Readme (Scenario zum Schluss)
      // TODO: Font.css einbauen?
      if (visdomRoot) {
        const readyCallback = () => window.VISDOM.load(visdomRoot,
          '../../static/libs/visdom/main.css',
          this.lat,
          this.lon,
          this.scenario,
          null,
          this.address);
        if (window.VISDOM && window.VISDOM.requestInstance !== undefined) {
          window.VISDOM.requestInstance(readyCallback);
        } else {
          readyCallback();
        }
      }
    },
    unloadHora3d (minimizeWindow) {
      if (window.VISDOM) {
        window.VISDOM.unload();
      }
      // console.log('unloadHora3d!')
      if (minimizeWindow) {
        WguEventBus.$emit(this.moduleName + '-visibility-change', false);
      }

      this.showHeaderToolbar = true;
    },
    updateAddress (adr) {
      this.address = adr[0];
      this.addressLon = adr[1];
      this.addressLat = adr[2];
    },
    /*
    onMapBound () {
      // the mixin 'Mapable' provides access to our OpenLayer map
      // via the variable 'this.map'
      // here we get the 'view' from the map
      const view = this.map.getView();
      // we call the function to extract zoom and center from the map
      // once it is initially created
      this.extractMapViewProperties(view);
      // to ensure that we react on updates of the map,
      // we need to register a listener
      view.on('change', () => {
        // always when the map view is changing we extract
        // the current zoom and center from it
        this.extractMapViewProperties(view);
      });
    }, */

    /**
     * We extract the current zoom and center coordinates
     * from the OpenLayers view and store the values
     * to our module's 'zoom' and 'center' variables
     *
     * @param {ol.View} view The OpenLayers view
     */
    extractMapViewProperties (view) {
      this.zoom = Math.round(view.getZoom());

      const sourceCrs = view.getProjection();
      const targetCrs = 'EPSG:4326';

      // we transform the coordinates from the map projection to WGS84 (EPSG:3857)
      const centerTargetCrs = transform(view.getCenter(), sourceCrs, targetCrs);
      this.lon = centerTargetCrs[0];
      this.lat = centerTargetCrs[1];
      // create a readable string from the coordinates
      this.center = toStringXY(
        centerTargetCrs,
        4 // <-- number of digits after comma
      );
    }
  }
};
</script>

<!-- Here we do the styling of our module -->
<style scoped>

.card3d {
  overflow: auto;
  left: 50% !important;
  right: 50% !important;
  top: 50% !important;
  transform: translate(-50%, -50%);  /* zentriert Fenster, bei kleinen Bildschirmen dann*/
  /*
  height: 90%;
  width: 90%;
  */

  /*
  max-width: 92%;
  max-height: 95%;
  */
  min-width: 250px;
  min-height: 250px;

  z-index: 55 !important;

}

.card3dFull {
  transform: unset;
  inset: 0 !important
}

.card3dFull.v-card > :last-child {
  overflow: visible;
}

.v-card > :last-child {
  overflow: auto;
  /* height: calc(100% - 70px); */
}

.v-application p {
  margin-bottom: 8px;
}

#hora3d {
  /* TODO: media für margin */
  /*
  margin: 0px 8px 8px 8px;
  width: calc(100% - 16px);
  height: calc(100% - 80px);
  */
  margin: 0px;
  width: 100%;
  height: 100%;

  /* height: 80vh; */ /* TODO height: 80vh nicht optimal */
  /* border: solid 1px red; */

  display: flex;
  position: absolute;

}

@media (max-width: 700px) {
  .adjustPadding {
    padding: 0 8px !important;
    letter-spacing: 0px;
    margin-left: 2px;
    margin-right: 2px;
  }
}

  /* avoid special color for links in footer */
  .card3d a {
    color: var(--v-onprimary-base);
  }

  .card3d a:hover {
    font-weight: bold;
    letter-spacing: -0.2px;
  }

</style>
